import {
    AdaptiveAuthenticationResult,
    FormattedAdaptiveAuthenticationResult
} from "@idw-types/data/adaptive-authentication-result/adaptive-authentication-result";

export const formatAdaptiveAuthenticationSearchResults = (
    results: Array<AdaptiveAuthenticationResult>
): Array<FormattedAdaptiveAuthenticationResult> => {
    return results.map(result => formatAdaptiveAuthenticationSearchResult(result));
};

export const formatAdaptiveAuthenticationSearchResult = (
    result: AdaptiveAuthenticationResult
): FormattedAdaptiveAuthenticationResult => {
    let date = null;
    if (result.date) {
        date = new Date(result.date);
    }
    
    return {
        date: date,
        loginDenied: result.loginDenied,
        mfaNewDevicesTrusted: result.mfaNewDevicesTrusted,
        mfaProfilingFailed: result.mfaProfilingFailed,
        mfaSuppressed: result.mfaSuppressed,
        totalLogins: result.totalLogins,
        uniqueUsers: result.uniqueUsers
    };
};